<template>
    <div class="relative rounded-3xl bg-cover bg-center text-white w-full h-[600px] mb-40" style="background-image: url('/assets/images/header2.jpg');">
      <div class="absolute inset-0 flex flex-col justify-between px-8 py-12">
        <div class="text-left max-w-lg">
          <h1 class="text-4xl font-bold mb-2" style="font-size:50px;">
            <span class="font-semibold text-black">Your Property,</span> <span class="font-bold text-black">Our Priority.</span>
          </h1>
          <p class="text-lg mb-6 text-black">Discover modern city living with our selection of premium properties all around Indonesia.</p>
        </div>
        <div>
        <div class="bg-transparent font-bold opacity-80 text-gray-800 w-full max-w-6xl mx-auto">
          <div class="flex space-x-4  ">
            <button :class="{'bg-white text-black': activeTab === 'Rent', 'bg-transparent text-gray-500': activeTab !== 'Rent'}" @click="activeTab = 'Rent'" class="px-4 py-2  rounded-tl-lg rounded-tr-lg">Rent</button>
            <button :class="{'bg-white text-black': activeTab === 'Buy', 'bg-transparent text-gray-500': activeTab !== 'Buy'}" @click="activeTab = 'Buy'" class="px-4 py-2 rounded-tl-lg rounded-tr-lg">Buy</button>
            <button :class="{'bg-white text-black': activeTab === 'Sell', 'bg-transparent text-gray-500': activeTab !== 'Sell'}" @click="activeTab = 'Sell'" class="px-4 py-2 rounded-tl-lg rounded-tr-lg">Sell</button>
          </div>
        </div>
        <div class="bg-white  font-bold opacity-80 text-gray-800 rounded-bl-lg rounded-br-lg shadow-lg p-6 w-full max-w-6xl mx-auto">
          <div class="flex bg-transparent flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4">
            <select class="border text-black bg-transparent border-gray-300 rounded-lg py-2 px-4 flex-1">
              <option>Location</option>
              <option>Jakarta</option>
              <option>Bali</option>
              <!-- Add more options as needed -->
            </select>
            <select class="border text-black bg-transparent border-gray-300 rounded-lg py-2 px-4 flex-1">
              <option>Property Type</option>
              <option>House</option>
              <option>Apartment</option>
              <!-- Add more options as needed -->
            </select>
            <select class="border text-black bg-transparent border-gray-300 rounded-lg py-2 px-4 flex-1">
              <option>Price Range</option>
              <option>$100,000 - $200,000</option>
              <option>$200,000 - $300,000</option>
              <!-- Add more options as needed -->
            </select>
            <button class="bg-primary text-white rounded-lg py-2 px-6">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2h8m-8 0a9 9 0 110-18 9 9 0 010 18z" />
              </svg>
            </button>
          </div>
        </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  export default {
    name: 'HeroSection',
    data() {
      return {
        activeTab: 'Rent',
      };
    },
  };
  </script>

  <style scoped>
  /* Add any additional styles here */
  </style>
